"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abort = exports.ajax = void 0;
const iquery_1 = require("@dustess/iquery");
const itimo_core_1 = require("@dustess/itimo-core");
const iconfig_env_runtime_1 = require("@dustess/iconfig-env-runtime");
const envManner = new iconfig_env_runtime_1.RuntimeEnvManager();
const { env } = envManner;
const baseURL = env.VUE_APP_PC_B_BASE_URL;
(0, iquery_1.interceptorsRequest)('Authorization', (config) => {
    var _a;
    const isMobile = /Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test((navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '');
    const targetKey = isMobile ? 'qw' : 'pc';
    const account = (_a = (0, itimo_core_1.getUser)(targetKey)) === null || _a === void 0 ? void 0 : _a.account;
    config.headers.Authorization = (0, itimo_core_1.getUserSid)(targetKey);
    account && (config.headers['x-auth-accountid'] = account);
});
const { request, abort } = (0, iquery_1.createAxios)({
    baseURL,
    // 自定义错误map
    errorMap: {},
});
exports.abort = abort;
function ajax(requestParams) {
    const { method, params } = requestParams;
    if (method === 'GET')
        requestParams.query = params;
    else
        requestParams.data = params;
    return request(requestParams);
}
exports.ajax = ajax;
//# sourceMappingURL=ajax.js.map